import React from 'react';
import { Facebook, Instagram, Youtube, Phone, Mail, MapPin, Linkedin, ClipboardCheck } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-gray-950 to-black border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8 mb-12">
          {/* Logo & Description */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center mb-6">
              <img 
                src="/Ib-logo.webp" 
                alt="Best Bungee Jump - Price, Location, Height, Booking Guide" 
                className="h-20 w-auto"
              />
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed mb-6 font-light">
              Indias leading bungee jumping operator with more 10 years of experience and 50,000 successful jumps. Experience the thrill of a lifetime with certified instructors and premium safety gear.
            </p>
            {/* Social Links */}
            <div className="flex flex-wrap gap-3">
              <a
                href="https://www.instagram.com/indyabungy/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/5 hover:bg-pink-500 flex items-center justify-center transition-all duration-300 transform hover:scale-110"
                aria-label="Instagram"
              >
                <Instagram size={18} className="text-white" />
              </a>
              <a
                href="https://www.youtube.com/@INDYABUNGY"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/5 hover:bg-red-500 flex items-center justify-center transition-all duration-300 transform hover:scale-110"
                aria-label="YouTube"
              >
                <Youtube size={18} className="text-white" />
              </a>
              <a
                href="https://www.snapchat.com/add/indya.bungy?share_id=pqLCTVesrII&locale=en-IN"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300 transform hover:scale-110"
                aria-label="Snapchat"
              >
                <img 
                  src="/snapchat.png"
                  alt="Snapchat"
                  className="w-6 h-6 object-contain"
                />
              </a>
              <a
                href="https://www.linkedin.com/company/indya-bungy/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/5 hover:bg-blue-600 flex items-center justify-center transition-all duration-300 transform hover:scale-110"
                aria-label="LinkedIn"
              >
                <Linkedin size={18} className="text-white" />
              </a>
              <a
                href="https://www.facebook.com/indyabungy"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/5 hover:bg-blue-500 flex items-center justify-center transition-all duration-300 transform hover:scale-110"
                aria-label="Facebook"
              >
                <Facebook size={18} className="text-white" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-400 hover:text-yellow-400 transition-colors text-sm flex items-center group">
                  <span className="inline-block transform group-hover:translate-x-1 transition-transform">Home</span>
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-yellow-400 transition-colors text-sm flex items-center group">
                  <span className="inline-block transform group-hover:translate-x-1 transition-transform">About Us</span>
                </Link>
              </li>
              <li>
                <Link to="/locations" className="text-gray-400 hover:text-yellow-400 transition-colors text-sm flex items-center group">
                  <span className="inline-block transform group-hover:translate-x-1 transition-transform">Locations</span>
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="text-gray-400 hover:text-yellow-400 transition-colors text-sm flex items-center group">
                  <span className="inline-block transform group-hover:translate-x-1 transition-transform">Gallery</span>
                </Link>
              </li>
              <li>
                <Link to="/franchise" className="text-gray-400 hover:text-yellow-400 transition-colors text-sm flex items-center group">
                  <span className="inline-block transform group-hover:translate-x-1 transition-transform">Franchise</span>
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-yellow-400 transition-colors text-sm flex items-center group">
                  <span className="inline-block transform group-hover:translate-x-1 transition-transform">Contact Us</span>
                </Link>
              </li>
              <li>
                <Link to="/web-checkin" className="text-yellow-400 hover:text-yellow-300 transition-colors text-sm flex items-center group font-semibold">
                  <ClipboardCheck size={16} className="mr-2" />
                  <span className="inline-block transform group-hover:translate-x-1 transition-transform">Web Check-in</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Policies */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6">Policies</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/terms" className="text-gray-400 hover:text-yellow-400 transition-colors text-sm flex items-center group">
                  <span className="inline-block transform group-hover:translate-x-1 transition-transform">Terms And Conditions</span>
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-400 hover:text-yellow-400 transition-colors text-sm flex items-center group">
                  <span className="inline-block transform group-hover:translate-x-1 transition-transform">Privacy Policy</span>
                </Link>
              </li>
              <li>
                <Link to="/refund" className="text-gray-400 hover:text-yellow-400 transition-colors text-sm flex items-center group">
                  <span className="inline-block transform group-hover:translate-x-1 transition-transform">Refund Policy</span>
                </Link>
              </li>
              <li>
                <Link to="/cancellation" className="text-gray-400 hover:text-yellow-400 transition-colors text-sm flex items-center group">
                  <span className="inline-block transform group-hover:translate-x-1 transition-transform">Cancellation Policy</span>
                </Link>
              </li>
              <li>
                <Link to="/safety" className="text-gray-400 hover:text-yellow-400 transition-colors text-sm flex items-center group">
                  <span className="inline-block transform group-hover:translate-x-1 transition-transform">Safety Guidelines</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Affiliations */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6">Affiliations</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/mot" className="text-gray-400 hover:text-yellow-400 transition-colors text-sm flex items-center group">
                  <span className="inline-block transform group-hover:translate-x-1 transition-transform">Ministry of Tourism</span>
                </Link>
              </li>
              <li>
                <Link to="/sanz" className="text-gray-400 hover:text-yellow-400 transition-colors text-sm flex items-center group">
                  <span className="inline-block transform group-hover:translate-x-1 transition-transform">SANZ Standards</span>
                </Link>
              </li>
              <li>
                <Link to="/atoai" className="text-gray-400 hover:text-yellow-400 transition-colors text-sm flex items-center group">
                  <span className="inline-block transform group-hover:translate-x-1 transition-transform">ATOAI</span>
                </Link>
              </li>
              <li>
                <Link to="/goa-tourism" className="text-gray-400 hover:text-yellow-400 transition-colors text-sm flex items-center group">
                  <span className="inline-block transform group-hover:translate-x-1 transition-transform">Goa Tourism</span>
                </Link>
              </li>
              <li>
                <Link to="/safety-standards" className="text-gray-400 hover:text-yellow-400 transition-colors text-sm flex items-center group">
                  <span className="inline-block transform group-hover:translate-x-1 transition-transform">Safety Standards</span>
                </Link>
              </li>
              <li>
                <Link to="/equipments" className="text-gray-400 hover:text-yellow-400 transition-colors text-sm flex items-center group">
                  <span className="inline-block transform group-hover:translate-x-1 transition-transform">Equipments</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6">Get In Touch</h3>
            <ul className="space-y-4">
              <li>
                <a href="tel:8506865393" className="flex items-start space-x-3 text-gray-400 hover:text-yellow-400 transition-colors text-sm group">
                  <Phone size={18} className="mt-0.5 flex-shrink-0 group-hover:scale-110 transition-transform" />
                  <span>8506865393</span>
                </a>
              </li>
              <li>
                <a href="mailto:crew.indyabungy@gmail.com" className="flex items-start space-x-3 text-gray-400 hover:text-yellow-400 transition-colors text-sm group">
                  <Mail size={18} className="mt-0.5 flex-shrink-0 group-hover:scale-110 transition-transform" />
                  <span>crew.indyabungy@gmail.com</span>
                </a>
              </li>
              <li>
                <div className="flex items-start space-x-3 text-gray-400 text-sm">
                  <MapPin size={18} className="mt-0.5 flex-shrink-0 text-yellow-400" />
                  <span>Multiple Locations Across India</span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Web Check-in CTA */}
        <div className="mb-8 bg-gradient-to-r from-yellow-400 to-yellow-500 rounded-2xl p-6 text-center">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="text-left">
              <h3 className="text-black font-bold text-xl mb-1 flex items-center">
                <ClipboardCheck className="mr-2" size={24} />
                Have a Confirmed Booking?
              </h3>
              <p className="text-black/80 text-sm">
                Complete your waiver form online before your jump
              </p>
            </div>
            <Link 
              to="/web-checkin"
              className="px-8 py-3 bg-black hover:bg-gray-900 text-yellow-400 font-bold rounded-lg transition-all duration-300 transform hover:scale-105 flex items-center gap-2 whitespace-nowrap"
            >
              <ClipboardCheck size={20} />
              Web Check-in
            </Link>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex flex-wrap justify-center md:justify-start gap-6">
              <Link to="/terms" className="text-gray-400 hover:text-yellow-400 transition-colors text-sm">
                Terms
              </Link>
              <Link to="/privacy" className="text-gray-400 hover:text-yellow-400 transition-colors text-sm">
                Privacy
              </Link>
              <Link to="/refund" className="text-gray-400 hover:text-yellow-400 transition-colors text-sm">
                Refund
              </Link>
              <Link to="/cancellation" className="text-gray-400 hover:text-yellow-400 transition-colors text-sm">
                Cancellation
              </Link>
              <Link to="/web-checkin" className="text-yellow-400 hover:text-yellow-300 transition-colors text-sm font-semibold">
                Web Check-in
              </Link>
              <Link to="/admin/login" className="text-gray-400 hover:text-yellow-400 transition-colors text-sm">
                Admin Login
              </Link>
            </div>
            <div className="text-gray-400 text-sm text-center md:text-right font-thin" style={{ fontFamily: 'Gibson, sans-serif', fontWeight: '100' }}>
              <p>© 2025 Indya Bungy brand of FLYSPORTS PROFESSIONAL INDIA PVT. LTD. All rights reserved.</p>
              <p>Designed and Managed By LOMS ONLINE SDN. BHD. Malaysia with passion for thrill seekers.</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
